export default __webpack_public_path__ + "static/media/profile-2.ef2edc4b.webp";